<cc-script-loader [scriptParams]="scriptParams" (scriptLoadedEvent)="scriptLoaded()" />

<!--
  loading: we intentionally load eager (not lazy) for now. Lazy would load the price once it's in the viewport.
      We only show labels once the component got initialized properly (which can take a second),
      with 'lazy' the user would see some layout shifts.
-->
<ng-container *ngrxLet="product$ as product">
  <!-- documentation: https://pages.git.i.mercedes-benz.com/dh-io-pls/dcps-product-pricing/v3/components/pls-ui -->
  <pls-ui
    [footnoteModuleId]="footnoteModuleId"
    [darkMode]="darkMode"
    [environment]="plsEnvironment"
    (initialize)="onPriceDisplayInitializeOrUpdate($event)"
    (update)="onPriceDisplayInitializeOrUpdate($event)"
    (disconnect)="onPriceDisplayDisconnected($event)"
    loading="eager"
  >
    <!-- configuration component is just used as 'data provider' to pass in the product and to determine if it is a stock car or configuration-->
    <pls-ui-configuration [product]="product" />

    <!-- label exists on purpse, also display none on purpose. this makes the "(exkl. MwSt.)" not to be rendered (in case of B2B) -->
    <pls-ui-label *ngIf="!isUsingUILabel" [style.display]="'none'" type="purchase-price" />
    <!-- in the owccc header we use the pls-ui-label, with this we are avoiding the skeleton issues. -->

    <pls-ui-label
      *ngIf="isUsingUILabel"
      [class.size-large]="size === 'large'"
      [class.centered]="isLabelCenteredOnMQ1"
      type="purchase-price"
      part="purchase-price"
    />

    <pls-ui-skeleton part="pls-ui-skeleton" />

    <!-- wrapper div necessary to align question mark icon right to the price (recommended solution by the price-display team) -->
    <div class="cc-price-display__price-value-wrapper" [class.centered]="isLabelCenteredOnMQ1">
      <pls-ui-value [class.size-large]="size === 'large'" type="purchase-price" part="purchase-price" />
      <pls-ui-breakdown [darkMode]="false" />
    </div>
  </pls-ui>
</ng-container>
